import React, { useState } from 'react'
import compose from 'recompose/compose'
import * as S from './styled'
import { withI18n } from '../../hocs'
import ModalForm from './form'
import {ModalReportConfirmation} from "../index";
import ActionDialog from '../action-dialog'
import {getCurrentSectionKey, SECTION_KEYS} from "../../../config/constants";
import eventTracker from "../../../utils/eventTracker";
import {toast} from "react-toastify";
import _ from "lodash";

const ExportInboxButton = ({ module, ids, fields, filters, sort, exportCsvOnBackground, i18n, offerFilters }) => {

    const [ open, setOpen ] = useState(false)
    const [ openConfirmation, setOpenConfirmation ] = useState(false);
    const [ reportFields, setReportFields ] = useState([]);

    // Con destinatarios devuelve la petición: ModalReportConfirmation muestra el spinner y se cierra
    // cuando ha ido bien. Si falla sigue abierto con el toast de error para poder reintentar
    const closeConfirmation = (receivers) => {
        if(receivers === 'Close' || _.isEmpty(receivers)){
            setOpenConfirmation(false);
            return;
        }

        const isPlanning = getCurrentSectionKey() === SECTION_KEYS.PLANNING;
        // Copia para no acumular el flag de planning en reportFields si se reintenta
        const exportFields = [...reportFields, isPlanning];

        return exportCsvOnBackground(exportFields, Object.keys(ids).length ? ids : filters, sort, module, isPlanning, receivers)
            .then(( res ) => {
                if(res.status !== 200) throw res;

                eventTracker.track('ReportExportedBackground Inbox', {
                    status: 'Success'
                });

                setOpenConfirmation(false);
                toast.success(i18n.reports.reportExportedSuccess, {
                    position: toast.POSITION.BOTTOM_CENTER
                })
            })
            .catch(() => {
                eventTracker.track('ReportExportedBackground Inbox', {
                    status: 'Failed'
                });

                toast.error(i18n.reports.reportExportedFailed, {
                    position: toast.POSITION.BOTTOM_CENTER
                })
            });
    }

    const exportCsvAndClose = (...args) => {
        setReportFields(...args);
        setOpenConfirmation(true);
        setOpen(false);

    }

    if(!fields || fields.length === 0){
        return null;
    }

    return (
        <>
            {/* Los botones los pinta ModalForm porque el estado de los campos marcados vive allí */}
            <ActionDialog
                open={open}
                title={i18n.modalCreateReport.createReport}
                onClose={() => setOpen(false)}
                showActions={false}
                disableBackdropClose
            >
                <S.ModalStyled>
                    {open &&
                        <ModalForm
                            module={module}
                            ids={ids}
                            fields={fields}
                            filters={filters}
                            sort={sort}
                            offerFilters={offerFilters}
                            onSubmit={exportCsvAndClose}
                            onCancel={() => setOpen(false)}
                        />
                    }
                </S.ModalStyled>
            </ActionDialog>
            <S.ButtonExport variant="contained" color="secondary" onClick={() => setOpen(true)} >
                {i18n.processesTable.export}
              ({(ids && ids.length > 0) ? ids.length : i18n.processesTable.all})
            </S.ButtonExport>
          <ModalReportConfirmation showModal={openConfirmation} handleClose={closeConfirmation}/>
        </>
    )
}

const enharce = compose(withI18n)

export default enharce(ExportInboxButton)